<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="user-chip"
          :color="getColor()"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          <v-avatar>
            <v-icon>account_circle</v-icon>
          </v-avatar>
          <v-progress-circular
            v-if="loading"
            :size="15"
            color="white"
            indeterminate
          />
          <span v-else>
            <template v-if="currentUser">
              {{ userName }} <b>({{ userId }})</b>
            </template>
            <template v-else>
              <i>{{ id }} - Not found</i>
            </template>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Open or Copy user details page
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'UserChip',
  props: {
    id: {
      type: Number,
      default: null,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentUser: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  computed: {
    userName() {
      if (this.currentUser) {
        return `${this.currentUser.data.naturalUser.firstName} ${this.currentUser.data.naturalUser.lastName}`;
      }

      return '';
    },
    userId() {
      if (this.currentUser) {
        return this.currentUser.ext_user_id || this.currentUser.id || this.currentUser.user_id || this.id;
      }

      return '';
    },
  },
  mounted() {
    if (this.user) {
      // User object provided, we can just assign and use it.
      this.currentUser = this.user;
    } else {
      // User object not provided, do user service call
      this.fetchUser();
    }
  },
  methods: {
    ...mapActions([
      'getUserByIdCached',
    ]),

    async fetchUser() {
      this.loading = true;
      try {
        this.currentUser = (await this.getUserByIdCached(this.id)).userMetaData;
        this.loading = false;
      } catch (error) {
        this.currentUser = null;
        this.isLoadUser = false;
        this.loading = false;
      }
    },
    onClick() {
      if (!this.loading && !this.currentUser) {
        return;
      }

      this.$router.push(`/users/onboarding-users/${this.id}`);
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
    getColor() {
      if (!this.loading && !this.currentUser) {
        return 'red';
      }

      return 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
.user-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/user/UserChip.vue